module.exports = __webpack_public_path__ + "img/kitchen.7dd9bf73.jpeg";